import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function BETSOFTLuckyWheel() {
  const data = promotionsData.find(
    (promo) => promo.title === "BETSOFT Lucky Wheel"
  )
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> BETSOFT Lucky Wheel </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion">Promotions</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> BETSOFT Weekly Lucky Wheel </h1>
                  <h2> Spin Now for Weekly Rewards</h2>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong> Promo Period: </strong>
                      <span> June 27 - July 31, 2025 </span>
                    </p>
                    <p>
                      <strong> Total Prize Pool: </strong>
                      <span> 328,640 PHP </span>
                    </p>
                  </div>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong>
                        Join the Take the Prize with BETSOFT Promotion and get a
                        chance to win a random fortune wheel with our Cash
                        prizes.
                      </strong>
                    </p>
                  </div>
                  <div className="promotion-tnc-mechanic-content">
                    <h1> Terms and Conditions: </h1>
                    <ol>
                      <li>No Minimum Bet.</li>
                      <li>Get lucky with only one spin.</li>
                      <li>
                        Take the Prize™ with Betsoft runs from June 27 to July
                        31, 2025, between 12:01 AM and 11:59 PM (UTC +8:00).
                      </li>
                      <li>
                        The Take the Prize™ includes total 328,640 PHP Cash
                        prizes.
                      </li>
                      <li>
                        In order to participate in the promotion, you are
                        required to play real money spin in all Betsoft Slots
                        games.
                      </li>
                      <li>
                        There is no additional cost to participate in the
                        promotions.
                      </li>
                      <li>The rules are built in the qualifying games.</li>
                      <li>
                        Prizes will be paid out as per the 'prizes' tab in the
                        qualifying games.
                      </li>
                      <li>
                        The prize table updates in real time showing number of
                        prizes left.
                      </li>
                      <li>
                        The prizes are paid out to the winners manually by
                        operator the day after the promotion ends.
                      </li>
                      <li>
                        General terms and conditions apply. We reserve the right
                        to modify the rules of the take the prize™ at any point
                        without prior notice.
                      </li>
                    </ol>
                    <div className="table-wrapper">
                      <table
                        className="promotion-tnc-table"
                        style={{ minWidth: "0" }}
                      >
                        <thead>
                          <tr>
                            <th>Week</th>
                            <th>Period</th>
                            <th>Prize</th>
                            <th>Winner List Release</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td> 1st Week </td>
                            <td> June 27 - July 3, 2025 </td>
                            <td> ₱82,160 </td>
                            <td> July 4, 2025 </td>
                          </tr>
                          <tr>
                            <td> 2nd Week </td>
                            <td> July 4 - July 10, 2025 </td>
                            <td> ₱82,160 </td>
                            <td> July 11, 2025 </td>
                          </tr>
                          <tr>
                            <td> 3rd Week </td>
                            <td> July 11 - July 17, 2025 </td>
                            <td> ₱82,160 </td>
                            <td> July 18, 2025 </td>
                          </tr>
                          <tr>
                            <td> 4th Week </td>
                            <td> July 18 - July 31, 2025 </td>
                            <td> ₱82,160 </td>
                            <td> August 1, 2025 </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="promotion-tnc-cta">
                      <a
                        href="/slots/?provider=BETSOFT"
                        className="promotion-cta-btn"
                        style={{ cursor: "pointer" }}
                      >
                        Play Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
